import React from 'react'
import PropTypes from 'prop-types'
import { StyledTableCell, StyledTableRow } from 'shared/components/Table';

export const ListItem = ({ index, data, no, handleOpenDialog, key }) => {

    return (
        <StyledTableRow key={key} onClick={handleOpenDialog}>
            <StyledTableCell align='center'>{no < 1 ? index + 1 : index < 9 ? `${no}${index + 1}` : `${no + 1}0`}</StyledTableCell>
            <StyledTableCell align='center'>{data.respondent.nip}</StyledTableCell>
            <StyledTableCell align='left'>{data.respondent.nama}</StyledTableCell>
            <StyledTableCell align='left'>{data.respondent.unker === null ? '-' : data.respondent.unker}</StyledTableCell>
            <StyledTableCell align='left'>{data.respondent.satker === null ? '-' : data.respondent.satker}</StyledTableCell>
        </StyledTableRow>
    )
}

ListItem.propTypes = {
    no: PropTypes.number,
    index: PropTypes.number,
    key: PropTypes.any,
    data: PropTypes.object.isRequired,
    handleOpenDialog: PropTypes.func,
};